import React, { useContext, useRef } from 'react'

import pages from './pages'
import api from 'Helpers/api'
import { getComponentType } from 'Helpers/transform'
import { useLocationPathChange, useQueryParams } from 'Hooks'
import { AppContext } from './contexts'

function PageComponentSelector({ inEditMode, onPageChanged }) {
  const { appContext, setAppContext } = useContext(AppContext)
  const { data } = appContext
  const componentType = getComponentType(data, pages)
  const DynamicComponent = pages[componentType || 'Page']
  const queryParams = useQueryParams()
  const latestRequestPathnameRef = useRef('')

  let path
  useLocationPathChange((pathname) => {
    path = pathname
    latestRequestPathnameRef.current = pathname
    setAppContext((previousAppContext) => ({
      ...previousAppContext,
      isLoading: true
    }))

    api.getContentByFriendlyUrl(pathname, queryParams)
      .then((responseData) => {
        if (latestRequestPathnameRef.current !== pathname) {
          return
        }

        setAppContext((previousAppContext) => ({
          ...previousAppContext,
          data: responseData,
          isLoading: false,
          header: responseData.Header || previousAppContext.defaultHeader || previousAppContext.header, // WELLBYCSO-77 - if the page has an overridden header or footer, use that instead of the default
          footer: responseData.Footer || previousAppContext.defaultFooter || previousAppContext.footer,
        }))

        onPageChanged(responseData)
      })
      .catch((error) => {
        console.log(error)
        if (latestRequestPathnameRef.current === pathname) {
          setAppContext((previousAppContext) => ({
            ...previousAppContext,
            isLoading: false
          }))
        }
      })
  })

  return (
    <div className={`main-container transition duration-500 ${appContext.isLoading ? 'opacity-0 animate-fade-out-down' : 'opacity-1 animate-fade-in-up'}`}>
      <DynamicComponent key={path} data={data} inEditMode={inEditMode} />
    </div>
  )
}

export default PageComponentSelector
